'use client';

import type { IChallengeClip } from '@repo/sdk';
import { Button } from '@repo/ui';
import { Loader2, Play, Scissors } from 'lucide-react';
import type { JSX } from 'react';

interface ICropRowActionsProps {
  clip: IChallengeClip;
  isCropping: boolean;
  onCrop: (clip: IChallengeClip) => void;
  onPreview: (clip: IChallengeClip) => void;
}

export function CropRowActions({
  clip,
  isCropping,
  onCrop,
  onPreview,
}: ICropRowActionsProps): JSX.Element {
  const canCrop = clip.cropStatus !== 'cropping' && clip.cropStatus !== 'uploading';

  return (
    <div className="flex items-center gap-1">
      {canCrop && (
        <Button variant="ghost" size="sm" onClick={() => onCrop(clip)} disabled={isCropping}>
          {isCropping ? (
            <Loader2 className="h-3.5 w-3.5 animate-spin" />
          ) : (
            <Scissors className="h-3.5 w-3.5" />
          )}
        </Button>
      )}
      {clip.baseLocalPath && (
        <Button variant="ghost" size="sm" onClick={() => onPreview(clip)}>
          <Play className="h-3.5 w-3.5" />
        </Button>
      )}
    </div>
  );
}
